<template>
	<div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
		<Navigator :select-index="2"/>
		<SliderBanner :data="slider"/>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-xl-8" style="text-align: center;">
					<h3 class="index-title">订单分佣方案</h3>
					<div class="tag"></div>
					<span class="index-desc"
						style="margin-top: 8px;">分佣方案可以设置方案模式、方案名称、等级类型、返佣类型、返佣设置、额外补贴和分销补贴等，对不同实体有不同的方案设置，方便不同门店的使用。</span>
				</div>
			</div>
		</div>
		<el-image :src="fg" fit="cover" >
		</el-image>
		
		<Info :items="infos"/>
		
		<Ad :data="ad"/>
		
		<Contact />
		<Footer />
	</div>
</template>

<script>
	import Navigator from '../index/widgets/navigator.vue'
	import Contact from "../index/widgets/Contact.vue"
	import Footer from '../index/widgets/footer.vue'
	
	import SliderBanner from "../local/widgets/SliderBanner.vue"
	import Info from "../local/widgets/Info.vue"
	import Ad from "../local/widgets/Ad.vue"
	export default {
		components: {
			Navigator,
			SliderBanner,
			Contact,
			Footer,
			Ad,
			Info,
		},
		data() {
			return {
				fg: require('@/assets/images/institution/fg.png'),
				slider: {
					image: require('@/assets/images/institution/phone.png'),
					title: '制度模式',
					desc: "有抽成设置、分佣方案、订单结算方案、提现制度设置等制度模式"
			
				},
				ad: {
					image: require('@/assets/images/local/ad.png'),
					title: '制度模式',
					desc: "有抽成设置、分佣方案、订单结算方案、提现制度设置等制度模式"
				},
				infos: [{
						title: '抽成设置',
						desc: '目前智莺系统可对淘宝联盟、京东联盟、多多进宝、唯品会、多多联盟、考拉赚钱、苏宁易购、饿了么、美团、百果园、喜茶、石化加油、电影票、麦当劳、星巴克、自营商城、多人拼团、区域代理、肯德基、汉堡王、滴滴打车、花小猪、瑞幸咖啡等多种平台的抽成设置',
						imgUrl: require("@/assets/images/institution/1.png"),
					},
					{
						title: '订单结算方案',
						desc: '订单结算方案可以设置方案名称、方案参数、最后更新时间、使用状态等，对不同实体有不同的方案设置，方便不同门店的使用。',
						imgUrl: require("@/assets/images/institution/2.png"),
					},
					{
						title: '提现制度设置',
						desc: '提现制度设置分为用户端和商家端两种提现制度设置，除了用户端有支付宝提现终端设置，其他设置都一样，可以设置提现频率、关闭提现窗口时提示、提现限制',
						imgUrl: require("@/assets/images/institution/3.png"),
					},
					
				]
			}
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width: 767px) {
		.bg {
			background-size: auto 500px;
			background-repeat: no-repeat;		
		}
	}
	
	@media (min-width: 767px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;		
		}
	}
	
	@media (min-width: 992px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;		
		}
	}
	
	.bg {
		background-image: url(../../assets/images/local/bg.png);
		// background-size: 100% 500px;
		
	}
</style>